/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 14-12-17.
 */
export const person = state => state.login;
